import { Trans } from '@lingui/react/macro';

import { useArticleContext } from '@/routes/Requests/contexts/ArticleContext';

import { BaseMessage } from './BaseMessage';

export const StartArticleExchangeTaskMessage = () => {
  const { article, iam } = useArticleContext();

  if (!iam.hasUserScopeOnArticle('stockLocation')) {
    return (
      <BaseMessage
        title={
          <Trans id="article.task.start-article-exchange.on-behalf.title">
            Workshop exchange required
          </Trans>
        }
        message={
          <Trans id="article.task.start-article-exchange.on-behalf.message">
            Please contact the workshop to validate the exchange on its behalf.
          </Trans>
        }
        article={article}
      />
    );
  }

  return (
    <BaseMessage
      title={<Trans id="article.task.start-article-exchange.title">Start the exchange</Trans>}
      message={
        <Trans id="article.task.start-article-exchange.message">
          Please click on the &quot;Start exchange&quot; button below. This will start the indicated
          exchange time.
        </Trans>
      }
      article={article}
    />
  );
};
